module.exports = __webpack_public_path__ + "static/flatart_ai_studio_header_04-7a28feb5bf180c71cbd370618d1cde04.webp";